import { Component } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AngularDraggableModule } from 'angular2-draggable';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UtilityHelper } from 'app/helpers/utilityHelper';

@Component({
    selector: 'app-leave-confirm-popup',
    imports: [AngularDraggableModule, MatButtonModule, MatIconModule, MatDialogModule],
    templateUrl: './leave-confirm-popup.component.html',
    styleUrls: ['./leave-confirm-popup.component.scss']
})
export class LeaveConfirmPopupComponent {
  isMentor:boolean;
  constructor(private dialogRef: MatDialogRef<LeaveConfirmPopupComponent>, private utlity: UtilityHelper) {}

  ngOnInit(){
    if(this.utlity.getItem('role') != 'mentor'){
      this.isMentor = true;
    }else{
      this.isMentor = false;
    }
  }
  closeDialog() {
    this.dialogRef.close(false); // return false
  }

  stay() {
    this.dialogRef.close(true); // return true
  }
}
